<template>
  <div class="presupuesto-interno-escalas-list">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="escalasFinanciacion" 
            :fields="fields">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
          <template v-slot:cell(montoMinimo)="data">
            <template v-if="data.item.montoMinimo == 0">
              ---.--
            </template>
            <template v-if="data.item.montoMinimo != 0">
              {{ data.item.montoMinimo | moneda }}
            </template>
          </template>
          <template v-slot:cell(montoMaximo)="data">
            <template v-if="data.item.montoMaximo == 0">
              ---.--
            </template>
            <template v-if="data.item.montoMaximo != 0">
              {{ data.item.montoMaximo | moneda }}
            </template>
          </template>
          <template v-slot:cell(pjeFinanciacion)="data">
            {{ data.item.pjeFinanciacion | porcentaje }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'PresupuestoInternoEscalasFinanciacion',
  props: {
    escalasFinanciacion: {
      type: Array,
      default: [],
    }    
  },
  data: () => {
    return {
      fields: [
        { key: 'montoMinimo' },
        { key: 'montoMaximo' },
        { key: 'pjeFinanciacion' }
      ],

      tableBusy: false,
    }
  },
}
</script>

<!-- <style>
  .clientes-search-list .registro table td[aria-colindex="1"] {
    width: 10%;
  }
  .clientes-search-list .registro table td[aria-colindex="2"],
  .clientes-search-list .registro table td[aria-colindex="3"] {
    width: 45%;
  }
</style> -->
